const About = () => {
  const aboutList = [
    {
      img: "/images/about1.png",
      txt1: "당일문의 당일해결",
      txt2: "잠수탄 세입자분의 방을 정리해야 하거나",
      txt3: "급하게 집을 싹 정리해야하는 상황이시라면",
      txt4: "당일해결 가능한 싹! 치워드림이",
      txt5: "깔금하게 해결해드리겠습니다.",
    },
    {
      img: "/images/about2.png",
      txt1: "출장비 없는 출장견적",
      txt2: "서울 경기 인천 전지역 어디라도",
      txt3: "수도권 전지역 출장비 없는 출장견적으로",
      txt4: "오차없는 견적산출로 보다 정확한",
      txt5: "견적으로 고객님을 찾아갑니다.",
    },
    {
      img: "/images/about3.png",
      txt1: "높은\u00A0퀄리티의\u00A0정리\u00A0(비밀보장)",
      txt2: " ",
      txt3: "2번 확인해보시지 않도록!",
      txt4: "오랜 경험과 노하우로 축적된",
      txt5: "깔끔하고 완벽한 정리 약속드립니다.",
    },
    {
      img: "/images/about4.png",
      txt1: "다양한 집정리 해결",
      txt2: " ",
      txt3: "유품정리 빈집정리 고독사유품정리 등등",
      txt4: "물건을 싹 정리해야하는 어떤 종류의 문의도",
      txt5: "마다하지 않고 해결 가능합니다.",
    },
  ];
  return (
    <div
      id="about"
      className="relative w-full h-full px-[calc((100%-var(--container))/2)] mx-auto py-14 lg:py-28 xl:pb-36"
    >
      <div
        id="title"
        className="relative w-full h-fit text-center mb-5 xl:mb-10"
      >
        <h2 className="font-medium">
          <span className="text-primary">싹!&nbsp;치워드림</span>에서 드리는
          4가지&nbsp;혜택
        </h2>
      </div>
      <div className=" relative w-full h-[1px] max-w-[1600px] mx-auto bg-black opacity-5 mb-5 xl:mb-10"></div>
      <div className="relative w-full h-fit max-w-[1600px] mx-auto grid grid-cols-1 lg:grid-cols-4 gap-2 lg:gap-4">
        {aboutList.map((v, i) => (
          <div
            key={i}
            data-aos="fade-up"
            className="relative w-full h-full p-3 border rounded-sm shadow-xl"
          >
            <div className="relative w-full h-72 xl:h-80 rounded-sm overflow-hidden">
              <img
                className="!relative w-full h-full object-cover hover:scale-110 transition-transform duration-300"
                alt={v.txt1}
                src={v.img}
                width={414}
                height={506}
              />
            </div>
            <div className=" relative w-full h-fit mt-5 text-center text-black">
              <h3 className="text-primary font-medium mb-2 scale-90">
                {v.txt1}
              </h3>
              <p className="">{v.txt2}</p>
              <p className="">{v.txt3}</p>
              <p className="">{v.txt4}</p>
              <p className="">{v.txt5}</p>
            </div>
          </div>
        ))}
      </div>
      <div className=" relative w-full h-fit max-w-[1600px] mx-auto bg-primary text-white text-center py-3.5 mt-6">
        <h3 className="font-medium">
          싹!&nbsp;치워드림은 모든&nbsp;물건을 치워드리는{" "}
          <span className="text-[#ffff00]">정리&nbsp;전문업체</span> 입니다
        </h3>
      </div>
    </div>
  );
};

export default About;
